export default __webpack_public_path__ + "static/media/bis-set.bd2f82cf.jpg";